<template>
    <li
        :data-component="$options.name"
        class="relative border border-solid rounded-10 border-wildsand shadow"
    >
        <a
            :href="bookmarkItem.detailUrl"
            class="flex flex-col screen-m:flex-row screen-m:p-16"
            target="_blank"
            data-jest-item
            @click="clickItem"
        >
            <div
                class="flex shrink-0 justify-center items-center w-full h-[277px] screen-m:w-[240px] screen-m:h-[175px] bg-color-brand-beige-50 screen-m:mr-16 rounded-t-10 screen-m:rounded-10"
            >
                <img
                    v-if="showExposeImage(bookmarkItem)"
                    class="object-center object-cover w-full h-full rounded-t-10 screen-m:rounded-10"
                    :src="isOwnInventoryOffline(bookmarkItem) ? fallBackExpiredExpose : bookmarkItem.smallImageUrl"
                    :alt="bookmarkItem.title"
                    data-jest-image
                    @error="onImageError"
                    @load="onImageLoad"
                />
                <ms-fallback-svg
                    v-else
                    class="w-80 h-80"
                    data-jest-fallback-svg
                />
                <div
                    v-if="isOwnInventoryOffline(bookmarkItem) || isImmoweltInventoryOffline"
                    class="absolute text-white font-bold"
                >
                    Angebot wurde deaktiviert
                </div>
            </div>

            <div
                class="flex flex-col grow overflow-hidden p-16 screen-m:p-0"
                :class="{ 'opacity-50': isOwnInventoryOffline(bookmarkItem) || isImmoweltInventoryOffline }"
            >
                <div class="flex flex-col screen-m:mr-[36px] text-caption-mobile screen-m:text-text-desktop">
                    <ms-headline
                        type="h4"
                        :isSpan="true"
                        class="mb-4 truncate"
                        >{{ bookmarkItem.title }}</ms-headline
                    >
                    <span class="mb-16 screen-m:mb-24 text-text truncate">{{ bookmarkItem.address }}</span>
                    <div class="flex flex-wrap mb-16 gap-x-24 gap-y-8 text-text-l">
                        <div
                            v-if="bookmarkItem.livingArea"
                            class="flex"
                        >
                            <ms-floor-plan class="w-24 h-24 mr-8" />
                            <p class="content-center">{{ bookmarkItem.livingArea }} m²</p>
                        </div>
                        <div
                            v-if="bookmarkItem.rooms"
                            class="flex"
                        >
                            <ms-door class="w-24 h-24 mr-8" />
                            <p class="content-center">{{ bookmarkItem.rooms }} Zimmer</p>
                        </div>
                        <div
                            v-if="bookmarkItem.landArea && showLandArea()"
                            class="flex"
                        >
                            <ms-surface class="w-24 h-24 mr-8" />
                            <p class="content-center">{{ bookmarkItem.landArea }} m²</p>
                        </div>
                    </div>
                </div>
                <hr class="mb-16" />
                <div class="flex justify-between items-center">
                    <cs-tag
                        v-if="isOwnInventory"
                        class="w-fit"
                        colorClass="bg-color-signatur-immo-100"
                        >{{ getOfferType() }} Angebot</cs-tag
                    >
                    <ms-immowelt-badge v-else />
                    <div class="flex flex-col text-right">
                        <span class="text-text-l font-bold">{{ bookmarkItem.price }}</span>
                        <span class="text-caption text-color-neutral-grey-60">{{ bookmarkItem.priceAppendix }}</span>
                    </div>
                </div>
            </div>
        </a>
        <button
            type="button"
            class="absolute top-0 right-0"
            aria-label="Remove item"
            @click="removeBookmark"
        >
            <ms-bookmark-filled
                class="w-24 h-24 m-10 text-color-alert-negative-100 transition-transform transform origin-center scale-100 hover:scale-110 active:animate-scale-up"
            />
        </button>
    </li>
</template>
<script lang="ts" src="./MsBookmarkItem.ts" />
<style scoped lang="scss">
@keyframes scale-up {
    50% {
        transform: scale(1.25);
    }
}

.animate-scale-up {
    animation: scale-up 0.25s cubic-bezier(0.77, -0.19, 0.33, 1.12);
}
</style>
